<app-ui-svg></app-ui-svg>

<section class="app-root">
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container">
      <a class="navbar-brand" [routerLink]="['/']"><svg-icon name="logo2"></svg-icon></a>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav">
          <ng-container *ngIf="notAuthorized$ | async">
            <li class="nav-item" *ngIf="keycloakAuth">
              <span class="nav-link" (click)="onKeycloakSignIn(); (false)">Keycloak Sign in</span>
            </li>
            <li class="nav-item" *ngIf="iamAuth">
              <a [routerLink]="['/iam', 'sign-in']" [routerLinkActive]="['active']" class="nav-link">IAM Sign in</a>
            </li>
          </ng-container>
          <ng-container *ngIf="authorized$ | async">
            <li class="nav-item" *ngIf="isRoot$ | async">
              <a [href]="consoleUrl" class="btn btn-default">Go to the Console</a>
            </li>
            <li class="nav-item" *ngIf="isIdentityAccount$ | async">
              <a [href]="appUrl" class="btn btn-active">Go to the App</a>
            </li>
            <li class="nav-item">
              <div class="nav-divider"></div>
            </li>
            <li class="nav-item dropdown" *ngIf="name$ | async as name">
              <a
                class="nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <svg-icon name="person"></svg-icon>
                {{ name }}
              </a>
              <div class="dropdown-menu dropdown-menu-dark dropdown-menu-end" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" *ngIf="isIAMAccount$ | async" (click)="onIAMAccountChangePassword(); false"
                  >Change password</a
                >
                <a class="dropdown-item version" (click)="$event.stopPropagation()" [cdkCopyToClipboard]="version"
                  >{{ version }} <svg-icon name="copy"></svg-icon
                ></a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" (click)="onSignOut(); (false)">Sign out</a>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </nav>

  <router-outlet></router-outlet>
</section>

<app-notice-feature-notice></app-notice-feature-notice>
